import { jsx as _jsx } from "react/jsx-runtime";
import { Autocomplete, Paper, TextField, Tooltip } from '@mui/material';
import { useMemo } from 'react';
import { useController, useFormContext, useWatch } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { columnTypeOperators } from '../api';
import { defineStyles } from '../theme';
import { getDataType, getDefaultOperator } from './helpers';
const MIN_COLUMN_INPUT_WIDTH = 180;
const styles = defineStyles({
    textFieldInput: {
        minWidth: MIN_COLUMN_INPUT_WIDTH,
        '& .MuiInputBase-root': {
            pr: '30px !important',
        },
        '& .MuiInput-input': {
            display: 'flex',
            fontWeight: 'bold',
        },
        '& .MuiInputBase-hiddenLabel': {
            pt: 0,
        },
    },
    popperBox: {
        width: 'fit-content',
    },
});
const CustomPaper = (props) => {
    return _jsx(Paper, { ...props, sx: styles.popperBox });
};
const ConditionColumn = ({ control, disabled, andConditionsIndex, orConditionsIndex, filterColumns, }) => {
    const intl = useIntl();
    const { setValue } = useFormContext();
    const { field } = useController({
        control,
        name: `andConditions.${andConditionsIndex}.orConditions.${orConditionsIndex}.field`,
    });
    const { value, name } = field;
    const operatorValue = useWatch({
        name: `andConditions.${andConditionsIndex}.orConditions.${orConditionsIndex}.operator`,
    });
    const fieldList = useMemo(() => filterColumns.map((i) => i.fieldName), [filterColumns]);
    return (_jsx(Autocomplete, { ...field, PaperComponent: CustomPaper, blurOnSelect: true, disabled: disabled, options: fieldList ?? [], onChange: (_, newValue) => {
            if (!newValue)
                return;
            field.onChange(newValue);
            const newDataType = getDataType(filterColumns, newValue);
            const allowedOperators = (newDataType && columnTypeOperators[newDataType]) ?? [];
            if (operatorValue && newDataType && allowedOperators.includes(operatorValue))
                return;
            const defaultOperator = getDefaultOperator(filterColumns, newValue);
            setValue(`andConditions.${andConditionsIndex}.orConditions.${orConditionsIndex}.operator`, defaultOperator);
        }, value: value?.toString() || null, clearIcon: false, noOptionsText: _jsx(FormattedMessage, { id: "autocomplete.no_options", defaultMessage: "No options" }), renderInput: (params) => {
            const val = value?.toString() ?? '';
            const dynamicMinWidth = val.length > 0
                ? `max(${MIN_COLUMN_INPUT_WIDTH}px, ${Math.max(20, val.length + 8)}ch)`
                : MIN_COLUMN_INPUT_WIDTH;
            return (_jsx(Tooltip, { title: val.trim() || null, children: _jsx("span", { children: _jsx(TextField, { ...params, name: name, size: "small", sx: [styles.textFieldInput, { minWidth: dynamicMinWidth }], hiddenLabel: true, placeholder: intl.formatMessage({
                            id: 'tableFiltering.column.placeholder',
                            defaultMessage: 'Column',
                        }) }) }) }));
        } }));
};
export default ConditionColumn;
//# sourceMappingURL=ConditionColumn.js.map